// extracted by mini-css-extract-plugin
module.exports = {"promotion_manager":"region_promotion_manager__2AN3c","card":"region_card__150VZ"};